import { render, staticRenderFns } from "./Myboard.vue?vue&type=template&id=75ed35a0&scoped=true&"
import script from "./Myboard.vue?vue&type=script&lang=js&"
export * from "./Myboard.vue?vue&type=script&lang=js&"
import style0 from "./Myboard.vue?vue&type=style&index=0&id=75ed35a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ed35a0",
  null
  
)

export default component.exports